/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    asset: "I. Biến động vốn chủ sở hữu",
    assetBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    value: {
      present: "",
      sddn_2021: "",
      sddn_2022: "",
      stg_2021_tang: "",
      stg_2021_giam: "",
      stg_2022_tang: "",
      stg_2022_giam: "",
      sdcn_2021: "",
      sdcn_2022: "",
    },
  },
  {
    id: 1,
    asset: "1. Vốn đầu tư của chủ sở hữu",
    assetBold: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 2,
    asset: "1.1. Cổ phiếu phổ thông có quyền biểu quyết",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 3,
    asset: "1.2. Cổ phiếu ưu đãi",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 4,
    asset: "1.3. Thặng dư vốn cổ phần",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 5,
    asset: "1.4. Quyền chọn chuyển đổi trái phiếu - Cấu phần vốn",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 6,
    asset: "1.5. Vốn khác của chủ sở hữu",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 7,
    asset: "2. Cổ phiếu quỹ (*)",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 8,
    asset: "3. Quỹ dự trữ bổ sung vốn điều lệ",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 9,
    asset: "4. Quỹ dự phòng tài chính và rủi ro nghiệp vụ",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 10,
    asset: "5. Chênh lệch đánh giá lại tài sản theo giá trị hợp lý",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 11,
    asset: "6. Chênh lệch tỷ giá hối đoái",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 12,
    asset: "7. Các Quỹ khác thuộc vốn chủ sở hữu",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 13,
    asset: "8. Lợi nhuận chưa phân phối",
    assetBold: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 14,
    asset: "8.1 Lợi nhuận sau thuế đã thực hiện",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 15,
    asset: "8.2 Lợi nhuận chưa thực hiện",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 16,
    asset: "Tổng cộng",
    assetBold: true,
    assetCenter: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 17,
    asset: "II. Thu nhập toàn diện khác ",
    assetBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    value: {
      present: "",
      sddn_2021: "",
      sddn_2022: "",
      stg_2021_tang: "",
      stg_2021_giam: "",
      stg_2022_tang: "",
      stg_2022_giam: "",
      sdcn_2021: "",
      sdcn_2022: "",
    },
  },
  {
    id: 18,
    asset: "1. Lãi/lỗ từ đánh giá lại các TSTC sẵn sàng để bán",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 19,
    asset: "2. Lãi, lỗ đánh giá lại TĐ theo mô hình giá trị hợp lý",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 20,
    asset: "3. Lãi, lỗ chênh lệch tỷ giá của hoạt động tại nước ngoài",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 21,
    asset: "4. Lãi, lỗ toàn diện khác",
    assetBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
  {
    id: 22,
    asset: "Tổng cộng",
    assetCenter: true,
    assetBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: {
      present: "",
      sddn_2021: 0,
      sddn_2022: 0,
      stg_2021_tang: 0,
      stg_2021_giam: 0,
      stg_2022_tang: 0,
      stg_2022_giam: 0,
      sdcn_2021: 0,
      sdcn_2022: 0,
    },
  },
];

function Table5({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan={3}>
                Chỉ tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan={3}>
                Thuyết minh
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan={2}>
                Số dư đầu năm
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan={4}>
                Số tăng giảm
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan={2}>
                Số dư cuối năm
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan={2}>
                2021
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan={2}>
                2022
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan={2}>
                2021
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan={2}>
                2022
              </Th>

              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan={2}>
                2021
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan={2}>
                2022
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tăng</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Giảm</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tăng</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Giảm</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>A</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>B</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>1</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>2</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>3</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>4</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>5</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>6</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>7</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>8</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChange}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  {/* --------- */}
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="sddn_2021"
                      readOnly={rows.readOnly}
                      value={rows.value.sddn_2021}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="sddn_2022"
                      readOnly={rows.readOnly}
                      value={rows.value.sddn_2022}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  {/* --------- */}
                  {/* --------- */}
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="stg_2021_tang"
                      readOnly={rows.readOnly}
                      value={rows.value.stg_2021_tang}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="stg_2021_giam"
                      readOnly={rows.readOnly}
                      value={rows.value.stg_2021_giam}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  {/* --------- */}
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="stg_2022_tang"
                      readOnly={rows.readOnly}
                      value={rows.value.stg_2022_tang}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="stg_2022_giam"
                      readOnly={rows.readOnly}
                      value={rows.value.stg_2022_giam}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  {/* --------- */}
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="sdcn_2021"
                      readOnly={rows.readOnly}
                      value={rows.value.sdcn_2021}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="sdcn_2022"
                      readOnly={rows.readOnly}
                      value={rows.value.sdcn_2022}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  {/* --------- */}
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(Table5);

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
